import React from 'react'

const TagsFilter = ({
  title,
  tags,
  selected,
  onToggle,
  language,
  categoryLabels,
  rarityLabels,
  statusLabels,
  articleTypeLabels, // Добавлен новый пропс
}) => {
  const getLabel = (tag) => {
    if (articleTypeLabels && articleTypeLabels[language]?.[tag])
      return articleTypeLabels[language][tag]
    if (categoryLabels && categoryLabels[language]?.[tag])
      return categoryLabels[language][tag]
    if (rarityLabels && rarityLabels[language]?.[tag])
      return rarityLabels[language][tag]
    if (statusLabels && statusLabels[language]?.[tag])
      return statusLabels[language][tag]
    return tag
  }

  return (
    <div className="tags-filter">
      <h3 className="tags-filter__title">{title}</h3>
      <div className="tags-filter__list">
        {tags.map((tag) => (
          <button
            key={tag}
            className={`tags-filter__item ${
              selected.includes(tag) ? 'active' : ''
            }`}
            onClick={() => onToggle(tag)}
          >
            {getLabel(tag)}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TagsFilter
